import i18next from 'i18next';

import { getURLSearchParamByKey } from 'src/utils';

const locale = getURLSearchParamByKey('locale');

i18next.init({
  fallbackLng: locale || 'tw',
  resources: {
    tw: {
      translations: require('../locales/tw/translations.json'),
    },
    en: {
      translations: require('../locales/en/translations.json'),
    },
    jp: {
      translations: require('../locales/jp/translations.json'),
    },
  },
  ns: ['translations'],
  defaultNS: 'translations',
  returnObjects: true,
  debug: process.env.NODE_ENV === 'development',
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
  react: {
    wait: true,
  },
});

i18next.languages = ['tw', 'en', 'jp'];

const t = i18next.t;

export { t };

export default i18next;
